<template>
  <div>
    <v-row no-gutters style="margin-top: 150px; margin-bottom: 40px">
      <v-col cols="12" class="text-md-h4 text-h5 text-center px-4 font-weight-bold">
        What are people saying about Bounty Hunter?
      </v-col>

      <v-col cols="12" class="text-body-1 font-weight-thin text-center mt-4">
        Earning money on Bounty Hunter made as simple as possible
      </v-col>
    </v-row>

    <v-row no-gutters style="margin-bottom: 50px">
      <v-col cols="12">
        <v-carousel height="410" hide-delimiters hide-delimiter-background :show-arrows="true" class="w-100">
          <template v-slot:prev="{ props }">
            <v-row class="fill-height my-2 mx-2 justify-end" align="end">
              <v-btn icon @click="props.onClick" class="ma-2  " color="arrowButton">
                <v-icon> <left-arrow /> </v-icon>
              </v-btn>
            </v-row>
          </template>

          <template v-slot:next="{ props }">
            <v-row class="fill-height my-2 mx-2 justify-start" align="end">
              <v-btn icon @click="props.onClick" class="ma-2  " color="arrowButton">
                <v-icon> <right-arrow /> </v-icon>
              </v-btn>
            </v-row>
          </template>

          <v-carousel-item v-for="carouselIndex in n" :key="carouselIndex" class="mt-4">
            <div class="d-flex align-stretch justify-center">
              <FeedbackTile v-for="index in getTaskIndices(carouselIndex - 1)" :key="index" :name="feedbacks[index].name"
                :review="feedbacks[index].review" class="ma-2 pa-4 feedback-grid" />
            </div>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useDisplay } from "vuetify";
import LeftArrow from "@/icons/LeftArrow.vue";
import FeedbackTile from "./Feedback-Tile.vue";
import RightArrow from "@/icons/RightArrow.vue";

export default {
  name: "PeopleFeedback",
  components: {
    FeedbackTile,
    LeftArrow,
    RightArrow,
  },
  setup() {
    const feedbacks = ref([
      {
        name: "TheDominator1524",
        review:
          "I absolutely love this app. A great way to make money running videos and games. Super easy to use! I recommend it to everyone I know.",
      },
      {
        name: "Mohnish Venkatesan",
        review:
          "This app is awesome! Not only does it let you earn money easily, it also lets you get free coins in less than 3 mins.",
      },
      {
        name: "Mo Sh",
        review:
          "Great app... Very easy to use. No complaints so far. Certainly a wonderful way to earn some extra cash.",
      },
      {
        name: "Brittany Wiley",
        review:
          "Easy to use and no ads! You don't have to be fighting with ads constantly while try to complete an offer.",
      },
    ]);

    const { name } = useDisplay();

    const itemsPerScreen = computed(() => {
      switch (name.value) {
        case "xs":
          return 1;
        case "sm":
          return 1;
        case "md":
          return 2;
        case "lg":
          return 2;
        case "xl":
          return 3;
        case "xxl":
          return 4;
        default:
          return 2;
      }
    });

    const getTaskIndices = (carouselIndex) => {
      const startIndex = carouselIndex * itemsPerScreen.value;
      const endIndex = Math.min(
        startIndex + itemsPerScreen.value,
        feedbacks.value.length
      );
      return Array.from(
        { length: endIndex - startIndex },
        (_, i) => startIndex + i
      );
    };

    const n = computed(() =>
      Math.ceil(feedbacks.value.length / itemsPerScreen.value)
    );

    return {
      feedbacks,
      getTaskIndices,
      n,
    };
  },
};
</script>

<style scoped lang="scss">

.feedback-grid{
  width: 400px !important;
}

.v-btn:active {
  transform: none !important;
}

.v-carousel,
.v-carousel-item {
  height: 410px !important;
}

</style>
